import { useFlags } from 'launchdarkly-react-client-sdk';
import { Navigate, Outlet } from 'react-router-dom';

import type { LdFeatureFlags } from '@/config/features';
import LoadingPage from '@/pages/loading';

type LDBooleanFeatureFlag = {
  [K in keyof LdFeatureFlags]: LdFeatureFlags[K] extends boolean ? K : never;
}[keyof LdFeatureFlags];

type LDBooleanFeatureFlags = {
  [K in keyof LdFeatureFlags]: LdFeatureFlags[K] extends boolean ? LdFeatureFlags[K] : never;
};

const FlagGuard = ({ flag, isLdIdentityReady }: { flag: LDBooleanFeatureFlag; isLdIdentityReady: boolean }) => {
  const { [flag]: flagEnabled } = useFlags<LDBooleanFeatureFlags>();

  if (!isLdIdentityReady) return <LoadingPage />;

  if (!flagEnabled) return <Navigate to="/404" replace />;

  return <Outlet />;
};
FlagGuard.displayName = 'FlagGuard';

export default FlagGuard;
